import React from 'react';
import ItemList from '../components/ItemList';

function platosCombinados() {

  const platosCombinadosList = [
    { name: 'Sultán', description: 'Patatas gratinadas con kebab', price: '7,00€', img: "https://media-cdn.tripadvisor.com/media/photo-s/17/eb/78/e9/patatas-naturales-con.jpg" },
    { name: 'Plato Combinado', description: 'Ensalada, patatas fritas, carne kebab y salsa yogur', price: '7,00€', img: "https://pizzakebabmora.com/wp-content/uploads/2021/03/Plato-de-pollo-Patata.jpeg" },
    { name: 'Sultán Junior', description: 'Patatas gratinadas con kebab (tamaño pequeño)', price: '5,00€', img: "https://tb-static.uber.com/prod/image-proc/processed_images/f875c2e7b0666e16dfc2f29055a9b9f2/58f691da9eaef86b0b51f9b2c483fe63.jpeg" },
  ];





  return (
    <div id="platosComb" className="container mx-auto mt-8 px-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-4">Platos Combinados</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {platosCombinadosList.map((menu) => (
          <ItemList
            key={menu.key}
            name={menu.name}
            description={menu.description}
            price={menu.price}
            img={menu.img}
            menuPrice={menu.menuPrice}
            menuIncludes={menu.menuIncludes}
          />
        ))}
      </div>
    </div>
  );
}

export default platosCombinados;
